import styled from 'styled-components'

export const Content = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  > * {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  /* Estilos do scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`
